// do not sort!
import "prismjs/plugins/line-numbers/prism-line-numbers.css"
import "./src/prism-theme/material-dark.css"
import "@fortawesome/fontawesome-svg-core/styles.css"
